import React from "react";

const Forget = React.lazy(() => import("../../ForgotPassword"));
const Login = React.lazy(() => import("../../login"));
const ProjectSelection = React.lazy(() => import("../../projectSelection"));
const ResetPass = React.lazy(() => import("../../resetPass"));
const Verify = React.lazy(() => import("../../verification"));
const Layout = React.lazy(() => import("../../../Layout/Layout"));
const PublicVoucherViewer = React.lazy(() => import("../../Prints/PublicVoucherViewer"));

export const publicRoutes = [
  {
    path: "/",
    Component: Login,
  },
  {
    path: "/verify",
    Component: Verify,
  },
  {
    path: "/forgot",
    Component: Forget,
  },
  {
    path: "/reset",
    Component: ResetPass,
  },
  {
    path: "/projectSelection",
    Component: ProjectSelection,
  },
  {
    path: "/account",
    Component: Layout,
  },
  {
    path: "/public/*",
    Component: PublicVoucherViewer,
  },
];
